<template>
  <div>
    <a-drawer
      title="选择视频"
      :width="1100"
      :visible="visible"
      :body-style="{ paddingBottom: '10px', paddingTop: '0px' }"
      @close="onClose"
    >
      <a-tabs
        default-active-key="1"
        @change="changeTopTab"
        :tabBarStyle="{
          display: 'flex',
          justifyContent: 'flex-start',
          position: 'relative',
        }"
      >
        <a-tab-pane tab="我的视频" key="1">
          <div class="select_div">
            <a-select
              :default-value="selectKey"
              style="width: 240px"
              @change="handleChange"
            >
              <a-select-option
                value="1"
                :disabled="this.product_list.length > 1"
                :title="
                  this.product_list.length > 1 ? '多商品不可选择抖音下素材' : ''
                "
              >
                抖音号主页素材
              </a-select-option>
              <a-select-option value="E_COMMERCE"> 本地上传 </a-select-option>
              <a-select-option value="2">
                账号下素材（数据版）
              </a-select-option>
              <a-select-option value="3"> 素材库 </a-select-option>
              <a-select-option value="LIVE_HIGHLIGHT">
                直播剪辑素材
              </a-select-option>
              <a-select-option value="BP">
                巨量引擎工作台共享素材
              </a-select-option>
              <a-select-option value="VIDEO_CAPTURE">
                易拍APP共享素材
              </a-select-option>
              <a-select-option value="ARTHUR"> 亚瑟共享素材 </a-select-option>
              <a-select-option value="STAR">
                星图&即合共享素材
              </a-select-option>
              <a-select-option value="TADA"> tada共享素材 </a-select-option>
              <a-select-option value="CREATIVE_CENTER">
                巨量创意PC共享素材
              </a-select-option>
            </a-select>

            <a-select
              class="filterItem"
              style="width: 150px; margin-left: 10px"
              @change="handleTeamChange"
              v-model="team_user_id"
              v-if="selectKey == '3'"
            >
              <a-select-option
                v-for="(item, index) in teamList"
                :key="index"
                :value="item.id"
              >
                {{ item.nickname }}
              </a-select-option>
            </a-select>

            <a-input-search
              placeholder="搜索视频id"
              v-model="searchKey"
              style="width: 200px; margin-left: 20px"
              @change="getData"
              :allowClear="true"
              v-if="selectKey == '1'"
            />
            <a-input-search
              placeholder="搜索视频id"
              v-model="searchKey"
              style="width: 200px; margin-left: 20px"
              @change="getAccountData(0)"
              :allowClear="true"
              v-else-if="selectKey == '2'"
            />
            <a-input-search
              placeholder="搜索文件夹名称/文件名称"
              v-model="searchKey"
              style="width: 250px; margin-left: 20px"
              @change="fetchFileList(false)"
              :allowClear="true"
              v-else-if="selectKey == '3'"
            />
            <a-input-search
              placeholder="搜索视频id/标题"
              v-model="searchKey"
              style="width: 200px; margin-left: 20px"
              :allowClear="true"
              @change="getQcDataSearch()"
              v-else
            />

            <a-input-search
              placeholder="搜索标签"
              v-model="tag"
              style="width: 150px; margin-left: 20px"
              @change="getQcDataSearch()"
              :allowClear="true"
              v-if="selectKey != '1' && selectKey != '2' && selectKey != '3'"
            />

            <a-checkbox
              style="margin-left: 10px; margin-top: 5px"
              :checked="dixiao == 1 ? true : false"
              @change="onDxChange"
              v-if="selectKey != '1' && selectKey != '2' && selectKey != '3'"
              >素材过滤</a-checkbox
            >

            <a-checkbox
              style="margin-left: 10px; margin-top: 5px; margin-right: 10px"
              :checked="having_cost == 1 ? true : false"
              @change="onCostChange"
              v-if="selectKey == '2'"
              >有消耗</a-checkbox
            >

            <a-select
              :default-value="sortby"
              style="width: 240px"
              @change="handleSortChange"
              v-if="selectKey == '2'"
            >
              <a-select-option value="stat_cost"> 按消耗降序 </a-select-option>
              <a-select-option value="pay_order_amount">
                按成交金额降序
              </a-select-option>
              <a-select-option value="prepay_and_pay_order_roi">
                按支付ROI降序
              </a-select-option>
              <a-select-option value="pay_order_count">
                按成交订单数降序
              </a-select-option>
            </a-select>

            <a-checkbox
              style="margin-left: 10px; margin-top: 5px; margin-right: 10px"
              :checked="selectAll == 1 ? true : false"
              @change="onSelectChange"
              >全选</a-checkbox
            >

            <a-button
              @click="sysnAllVideo"
              v-if="selectKey != '1' && selectKey != '2' && selectKey != '3'"
              :loading="sysnloading"
              >同步视频数据</a-button
            >
          </div>
          <div class="tips" @click="sqvisible = true" v-if="selectKey == '1'">
            <a-alert
              message="【推商品】计划可筛选抖音下已挂车对应商品的素材视频，【推直播】计划可选中抖音下已发布视频"
              banner
              type="info"
              show-icon
              style="cursor: pointer"
            />
          </div>
          <div class="tips" @click="sqvisible = true" v-if="selectKey == '3'">
            <a-alert
              message="选择【本地素材库】上传的视频，同时支持同步至其他商品"
              banner
              type="info"
              show-icon
              style="cursor: pointer"
            />
          </div>
          <div
            class="tips"
            @click="sqvisible = true"
            v-if="selectKey != '1' && selectKey != '2' && selectKey != '3'"
          >
            <a-alert
              message="使用千川素材库视频时，若出现视频封面无法显示时，请务必勾选允许访问敏感素材，并重新授权！【点此去重新授权】"
              banner
              type="info"
              show-icon
              style="cursor: pointer"
            />
          </div>

          <!-- 添加面包屑导航 -->
          <div
            class="folder-navigation"
            v-if="
              selectKey == '3' && (currentCategoryId || folderPath.length > 0)
            "
          >
            <a-button
              type="link"
              @click="goToRootFolder"
              v-if="currentCategoryId || folderPath.length > 0"
            >
              <a-icon type="home" />根目录
            </a-button>
            <span v-for="(folder, index) in folderPath" :key="'nav-' + index">
              <a-icon type="right" />
              <a-button type="link" @click="navigateToFolder(index)">
                {{ folder.name }}
              </a-button>
            </span>
          </div>

          <a-spin :spinning="video_spinning" tip="加载中...">
            <div
              class="material-virtual-viewport"
              style="height: calc(100% - 74px)"
            >
              <div style="min-height: 900px">
                <div
                  class="material-row"
                  v-if="
                    ((list.length > 0 || video_spinning) &&
                      list[0] &&
                      list[0].video_cover_url !==
                        '素材所属主体与开发者主体不一致无法获取URL') ||
                    selectKey == '3'
                  "
                >
                  <div
                    @click="handleFolderClick(item)"
                    class="video-container file_box"
                    is-search-empty="true"
                    auth-type="2"
                    v-for="(item, index) in folderList"
                    :key="'fd-' + index"
                  >
                    <a href="javascript:;">
                      <div class="items-center folder-content">
                        <div>
                          <a-icon type="folder" class="mr-2 text-yellow-500" />
                        </div>
                        <span class="folder-name">{{ item.fileName }}</span>
                      </div>
                    </a>
                  </div>

                  <div
                    @click="selectVideo(item)"
                    class="video-container"
                    is-search-empty="true"
                    auth-type="2"
                    v-for="(item, index) in list"
                    :key="index"
                  >
                    <div
                      class="video-player video-player-size-normal no-select-border"
                    >
                      <div
                        class="video-player-poster"
                        :style="{ backgroundSize: 'cover' }"
                      >
                        <img
                          :src="item.video_cover_url"
                          alt=""
                          style="width: 100%; height: 100%"
                        />
                      </div>
                      <!-- <div class="video-player-mask"></div> -->
                      <span class="start-btn"></span>
                      <div class="card-duration">
                        {{ getTime(item.duration) }}
                      </div>
                      <div class="video-player-like" v-if="selectKey == '1'">
                        <a-icon
                          type="caret-right"
                          class="video-player-like-icon"
                        />
                        <span class="video-player-like-num">{{
                          item.view_cnt
                        }}</span>

                        <a-icon type="heart" class="video-player-like-icon" />
                        <span class="video-player-like-num">{{
                          item.like_cnt
                        }}</span>

                        <a-icon type="message" class="video-player-like-icon" />
                        <span class="video-player-like-num">{{
                          item.comment_cnt
                        }}</span>
                      </div>
                    </div>
                    <div class="byted-popover-wrapper">
                      <div class="video-player-file-name">
                        <a-tag color="red" v-if="item.is_dx">低效素材</a-tag
                        >{{ item.title || item.filename }}
                      </div>
                      <div v-if="item.tags">
                        <a-tag
                          color="cyan"
                          v-for="(tagItem, tagIndex) in item.tags"
                          :key="tagIndex"
                          >{{ tagItem }}</a-tag
                        >
                      </div>

                      <div class="statistic-wrapper" v-if="selectKey == '2'">
                        <div class="statistic-item">
                          <p class="label">消耗金额</p>
                          <p class="value">{{ item.stat_cost }}</p>
                        </div>
                        <div class="statistic-item">
                          <p class="label">成交金额</p>
                          <p class="value">{{ item.pay_order_amount }}</p>
                        </div>
                        <div class="statistic-item">
                          <p class="label">支付ROI</p>
                          <p
                            class="value profit"
                            v-if="item.prepay_and_pay_order_roi < 2"
                          >
                            {{ item.prepay_and_pay_order_roi }}
                          </p>
                          <p class="value loss" v-else>
                            {{ item.prepay_and_pay_order_roi }}
                          </p>
                        </div>
                      </div>

                      <span
                        style="font-size: 12px; color: #999"
                        v-if="selectKey == '1'"
                        >视频ID:{{ item.aweme_item_id }}</span
                      >
                      <span
                        style="font-size: 12px; color: #999"
                        v-else-if="selectKey == '3'"
                        >{{ item.file_route }}</span
                      >
                      <span style="font-size: 12px; color: #999" v-else
                        >素材ID:{{ item.material_id }}</span
                      >
                      <div>
                        <span
                          style="font-size: 12px; color: rgb(255, 85, 0)"
                          v-if="item.v_createtime || item.create_time"
                          ><a-icon type="clock-circle" />
                          {{ item.v_createtime || item.create_time }}</span
                        >
                      </div>
                    </div>

                    <div class="selected-con" v-if="getStatus(item)">
                      <img
                        src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/eb4c48325f3c405da4a37af2b4dc8842~tplv-55ejei7tpt-image.image"
                        alt=""
                        class="selected-con-bg"
                      /><img
                        data-v-73a17e34=""
                        src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/44e1bcb881e3451b9a3185d60fe53882~tplv-55ejei7tpt-image.image"
                        alt=""
                        class="selected-con-icon"
                      />
                    </div>
                  </div>
                  <div v-if="selectKey == '1'">
                    <a-divider
                      v-if="video_hasmore"
                      style="padding-bottom: 60px; padding-top: 30px"
                    >
                      <span @click="getData(1)"
                        ><a href="javascript:void(0)">点此加载更多</a></span
                      >
                    </a-divider>
                    <a-divider
                      v-else
                      style="padding-bottom: 60px; padding-top: 30px"
                    >
                      <span>暂无更多视频</span>
                    </a-divider>
                  </div>
                  <div v-if="selectKey == '2'">
                    <a-divider
                      v-if="video_hasmore"
                      style="padding-bottom: 60px; padding-top: 30px"
                    >
                      <span @click="getAccountData(1)"
                        ><a href="javascript:void(0)">点此加载更多</a></span
                      >
                    </a-divider>
                    <a-divider
                      v-else
                      style="padding-bottom: 60px; padding-top: 30px"
                    >
                      <span>暂无更多视频</span>
                    </a-divider>
                  </div>
                  <div
                    v-if="
                      selectKey != '1' && selectKey != '2' && selectKey != '3'
                    "
                  >
                    <a-divider style="padding-bottom: 60px; padding-top: 30px">
                      <span @click="getMoreQcData()"
                        ><a href="javascript:void(0)">点此加载更多</a></span
                      >
                    </a-divider>
                    <!-- <a-divider  v-else style="padding-bottom: 60px;">
                      <span>暂无更多视频</span>
                    </a-divider> -->
                  </div>
                  <div v-if="selectKey == '3'">
                    <a-divider style="padding-top: 30px">
                      <span @click="fetchFileList(true)"
                        ><a href="javascript:void(0)">点此加载更多</a></span
                      >
                    </a-divider>
                  </div>
                </div>
                <div
                  @click="sqvisible = true"
                  style="color: red; cursor: pointer"
                  v-else-if="
                    list[0] &&
                    list[0].video_cover_url ==
                      '素材所属主体与开发者主体不一致无法获取URL'
                  "
                >
                  您尚未授权允许访问敏感素材，点击链接前往授权！
                </div>
                <div class="empty" v-else>
                  <a-empty />
                </div>
              </div>
            </div>
          </a-spin>
        </a-tab-pane>
        <a-tab-pane tab="上传视频" key="2">
          <div style="height: 250px">
            <a-upload-dragger
              name="file"
              :show-upload-list="false"
              :multiple="true"
              @change="handleVideoChange"
              :customRequest="uploadFile"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" />
              </p>
              <p class="ant-upload-text">点击上传视频</p>
              <p class="ant-upload-hint">
                横版: 宽高比16: 9，视频码率≥516kbps, 大小≤1000M,
                2560*1440≥分辨率≥1280*720,300s≥时长≥4s
              </p>
              <p class="ant-upload-hint">
                竖版: 宽高比9: 16，视频码率≥516kbps, 大小≤1000M,
                1440*2560≥分辨率≥720*1280,300s≥时长≥4s
              </p>
            </a-upload-dragger>
          </div>
          <div class="upload-actions" style="margin: 16px 0">
            <a-button
              type="primary"
              @click="retryFailedUploads"
              :disabled="!uploadlist.some((file) => file.status === '上传失败')"
            >
              重试失败的上传
            </a-button>
          </div>
          <a-spin :spinning="spinning" tip="加载中...">
            <div style="background-color: #fff; z-index: 999">
              <a-table
                :rowKey="(record) => record.uid"
                :columns="columns"
                :data-source="uploadlist"
              >
                <div slot="percents" slot-scope="text">
                  <a-progress :percent="text.percent" :show-info="false" />
                </div>
                <div slot="status" slot-scope="text">
                  <span
                    style="color: green"
                    v-if="
                      text.status == '上传中' ||
                      text.status == '同步至千川素材库' ||
                      text.status == '上传成功'
                    "
                    >{{ text.status }}</span
                  >
                  <span style="color: red" v-else>
                    {{ text.status }}
                    <a-button
                      type="link"
                      v-if="text.status === '上传失败'"
                      @click="retrySingleUpload(text)"
                    >
                      重试
                    </a-button>
                  </span>
                </div>
                <div slot="action" slot-scope="text">
                  <span @click="removeItem(text)" style="cursor: pointer"
                    >移除</span
                  >
                </div>
              </a-table>
            </div>
          </a-spin>
        </a-tab-pane>
      </a-tabs>

      <div :style="{}" class="drawerFooter">
        <div class="drawer-footer-materials">
          <div class="select-small-list-container">
            <div
              class="image-con"
              v-for="(item, index) in select_video_list"
              :key="index"
            >
              <div class="image-con-container">
                <img
                  :src="item.video_cover_url"
                  alt=""
                  class="bg-image"
                  style="width: 100%"
                />
              </div>
              <img
                src="https://p1-ad.byteimg.com/tos-cn-i-yt5q7rszul/abbc32596f064ad8a1e35642e0bcb29c~tplv-yt5q7rszul-image.image"
                alt=""
                class="video-icon-image"
              />
              <img
                src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/cbed3bb01ba24fb38e68406460567cb4~tplv-55ejei7tpt-image.image"
                alt=""
                class="delete-icon-image"
                @click="delsc(item)"
              />
            </div>
          </div>
        </div>

        <div class="drawer-footer-btns">
          <a-button :style="{ marginRight: '8px' }" @click="onClose">
            取消
          </a-button>
          <a-button :style="{ marginRight: '8px' }" @click="clearSelected">
            清空已选
          </a-button>
          <a-button type="primary" @click="onOk"> 确定已选 </a-button>
        </div>
      </div>
    </a-drawer>
    <a-modal
      v-model="sqvisible"
      title="新增授权提示"
      width="880px"
      class="authModal"
      centered
    >
      <div class="authTypeWapper">
        <img class="authImg" src="@images/authorize.png" alt="" />
      </div>
      <template slot="footer">
        <p class="authTxt">
          您需要进入巨量千川平台进行授权，点击"去授权"按钮跳转将至
        </p>
        <p class="authTxt">
          官方后台进行授权，为确保投放数据的完整和准确，请授权投放抖音号的所有千川账户
        </p>
        <p class="authTxt">
          请务必勾《选敏感物料》，授权《选敏感物料》后，在创建广告时可以直接预览和使用千川账号下的已有素材。
        </p>
        <p class="authTxt">在您授权后成功之后，请稍后刷新页面查看</p>
        <div class="addbtn">
          <a-button type="primary" class="authBtn" @click="addAuth()"
            >官方授权</a-button
          >
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { qcApi, requestHttp, trim } from '@utils/index';
import TOS from '@volcengine/tos-sdk';
import { mapState } from 'vuex';
import { Modal, message } from 'ant-design-vue';
const columns = [
  {
    title: '视频信息',
    key: 'name',
    dataIndex: 'name',
    width: 330,
  },
  {
    title: '进度',
    key: 'percents',
    scopedSlots: { customRender: 'percents' },
  },
  {
    title: '状态',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: 'addVideo',
  props: {
    advertiser_id: {
      type: String,
      default: '',
    },
    marketing_goal: {
      type: String,
      default: '',
    },
    aweme_id: {
      type: String,
      default: '',
    },
    product_list: {
      type: Array,
    },
    newSelectList: {
      type: Array,
    },
  },

  data() {
    return {
      list: [],
      selectKey: '1',
      columns,
      uploadlist: [],
      page: 1,
      total: 10,
      spinning: false,
      visible: true,
      video_spinning: false,
      video_hasmore: false,
      video_cursor: '',
      select_video_list: this.newSelectList,
      searchKey: '',
      sqvisible: false,
      dixiao: 1,
      having_cost: 0,
      sortby: 'stat_cost',
      selectAll: 0,
      tag: '',
      sysnloading: false,
      sysnpage: 1,
      otherSelect: 0,
      folderList: [],
      currentCategoryId: '',
      mediaType: 'video',
      folderPath: [],
      currentUploadIndex: -1,
      isUploading: false,
      team_user_id: '',
      teamList: [],
    };
  },

  components: {},

  watch: {},

  computed: {
    ...mapState('User', ['wxInfo']),
  },
  mounted() {
    console.log('product_list----------', this.product_list);
    console.log('newSelectList----------', this.newSelectList);
    if (this.product_list.length > 1) {
      this.selectKey = 'E_COMMERCE';
      this.getQcData();
    } else {
      this.getData();
    }
  },

  methods: {
    onDxChange(e) {
      if (e.target.checked) {
        this.dixiao = 1;
      } else {
        this.dixiao = 0;
      }
      this.list = [];
      this.page = 1;
      if (this.selectKey == 1) {
        this.getData();
      }
      if (this.selectKey == 2) {
        this.getAccountData(0);
      } else {
        this.getQcData();
      }
      console.log('进来执行了' + this.selectKey, e.target.checked);
    },
    handleSortChange(value) {
      this.sortby = value;
      this.getAccountData();
    },
    onCostChange(e) {
      if (e.target.checked) {
        this.having_cost = 1;
      } else {
        this.having_cost = 0;
      }
      this.list = [];
      this.page = 1;
      if (this.selectKey == 1) {
        this.getData();
      }
      if (this.selectKey == 2) {
        this.getAccountData();
      } else {
        this.getQcData();
      }
      console.log(e.target.checked);
    },
    onSelectChange(e) {
      if (e.target.checked) {
        this.selectAll = 1;
        // 追加当前列表中的所有视频到已选列表
        this.list.forEach((item) => {
          if (
            !this.select_video_list.some((selected) => selected.id === item.id)
          ) {
            this.select_video_list.push(item);
          }
        });
      } else {
        this.selectAll = 0;
        // 从已选列表中移除当前列表中的所有视频
        this.select_video_list = this.select_video_list.filter(
          (selected) => !this.list.some((item) => item.id === selected.id)
        );
      }
    },
    onOtherChange(e) {
      if (e.target.checked) {
        this.otherSelect = 1;
      } else {
        this.otherSelect = 0;
      }
    },
    async addAuth() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QIANCHUAN_AUTH}`,
        method: 'POST',
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      const strUrl = data.url;
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.target = '_blank';
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    getStatus(item) {
      let res = this.select_video_list.filter(function (it) {
        return it.id == item.id;
      });
      return res.length > 0 ? 1 : 0;
    },
    delsc(item) {
      this.select_video_list = this.select_video_list.filter(function (it) {
        return it.id != item.id;
      });
    },
    selectVideo(item) {
      console.log('选中', item);
      if (this.getStatus(item) == 1) {
        this.select_video_list = this.select_video_list.filter(function (it) {
          return it.id != item.id;
        });
      } else {
        this.select_video_list.push(item);
      }
    },
    async getData(type = 0) {
      this.video_spinning = true;
      if (type == 0) {
        this.video_cursor = '';
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QC_AWEME_VIDEO_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          aweme_item_ids: this.searchKey,
          aweme_id: this.aweme_id,
          product_id:
            this.marketing_goal == 'VIDEO_PROM_GOODS'
              ? this.product_list[0].id
              : '',
          page: this.video_cursor,
          dixiao: this.dixiao,
        },
      });
      this.video_spinning = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.list =
        type == 1 ? this.list.concat(data.video_list) : data.video_list;
      if (this.list.length > 0) {
        this.selectAll = 0;
        this.list.forEach((item) => {
          (item.id = item.aweme_item_id),
            (item.source = 'DOUYIN'),
            (item.type = 'VIDEO'),
            (item.video_title = item.title);
          (item.image_mode = 'VIDEO_VERTICAL'), //强制使其为竖版视频测试用
            (item.imageUrl = item.video_cover_url);
        });
      }
      this.video_hasmore = data.page_info.has_more;
      this.video_cursor = data.page_info.cursor;
    },
    async getAccountData(type = 0) {
      this.video_spinning = true;
      if (type == 0) {
        this.page = 1;
      } else {
        this.page++;
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QIUANCHUAN_MATERIAL_GET_NEW}`,
        method: 'POST',
        params: {
          start_date: '',
          end_date: '',
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          marketing_scene: 'FEED',
          search_keyword: this.searchKey,
          material_type: 'VIDEO',
          sortby: this.sortby,
          sort: 'descend',
          page: this.page,
          pagesize: 10,
          having_cost: this.having_cost ? 'YES' : 'ALL',
        },
      });
      this.video_spinning = false;
      if (code == 0) {
        if (msg == '分页错误，请检查参数') {
          this.video_hasmore = false;
        } else {
          this.$message.error(msg);
          return;
        }
      }
      if (!data) return;
      if (data.list) {
        this.selectAll = 0;
        this.video_hasmore = true;
      } else {
        this.video_hasmore = false;
      }
      this.list = type == 1 ? this.list.concat(data.list) : data.list;
      if (this.list.length > 0) {
        this.list.forEach((item) => {
          (item.id = item.video_id),
            (item.source = 'QIANCHUAN'),
            (item.type = 'VIDEO'),
            (item.video_title = item.title);
          item.filename = item.title;
          item.title = '';
          // item.image_mode = item.image_mode, //强制使其为竖版视频测试用
          (item.imageUrl = item.web_url),
            (item.video_cover_url = item.web_url),
            (item.duration = item.video_duration);
        });
      }
    },
    async sysnVideo(source = '') {
      this.video_spinning = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QC_SYSN_VIDEO_BY_SCK}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          source: source ? source : this.selectKey,
          dixiao: this.dixiao,
          page: this.page,
        },
      });
      this.video_spinning = false;
      this.getQcData();
    },
    sysnAllVideo() {
      Modal.confirm({
        title: '提醒',
        content: '确定是否同步下千川素材库数据？',
        onOk: () => {
          this.video_spinning = true;
          this.sysnloading = true;
          this.getAllVideo();
        },
      });
    },
    async getAllVideo() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QC_SYSN_VIDEO_BY_SCK_DOWN}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          source: this.selectKey,
          page: this.sysnpage,
        },
      });
      if (data.list && data.list.length > 0) {
        this.sysnpage++;
        this.getAllVideo();
      } else {
        this.video_spinning = false;
        this.sysnloading = false;
        this.getQcDataSearch();
      }
    },
    getQcDataSearch() {
      this.list = [];
      this.page = 1;
      this.getQcData();
    },
    async getQcData(isselect = false) {
      this.video_spinning = true;
      console.log('xxxxxxxxx', this.searchKey);
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QC_GET_VIDEO_BY_SCK_NEW}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          source: this.selectKey,
          tag: this.tag,
          searchKey: this.searchKey,
          dixiao: this.dixiao,
          page: this.page,
        },
      });
      this.video_spinning = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      if (data.list.length > 0) {
        this.selectAll = 0;
        data.list.forEach((item) => {
          (item.source = 'QIANCHUAN'),
            (item.type = 'VIDEO'),
            (item.video_cover_url = item.poster_url),
            (item.imageUrl = item.poster_url),
            (item.video_title = item.filename);
          item.title = '';
        });
        this.list = this.list.concat(data.list);
        if (isselect) {
          this.select_video_list.push(data.list[0]);
        }
      }
    },
    getTime(value) {
      let secondTime = parseInt(value); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取余，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取余的分，获取分钟除以60取余的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      //若秒数是个位数，前面用0补齐
      secondTime = secondTime < 10 ? '0' + secondTime : secondTime;
      var result = '' + secondTime + '';
      if (minuteTime > 0) {
        //若分钟数是个位数，前面用0补齐
        minuteTime = minuteTime < 10 ? '0' + minuteTime : minuteTime;
        result = '' + minuteTime + ':' + result;
      } else {
        //若分钟数为0，用"00"表示
        result = '' + '00' + ':' + result;
      }

      if (hourTime > 0) {
        //若小时数是个位数，前面用0补齐
        hourTime = hourTime < 10 ? '0' + hourTime : hourTime;
        result = '' + hourTime + ':' + result;
      } else {
        //若小时数为0，用"00"表示
        // result =  result;
      }
      // console.log("result",result)
      return result;
    },
    changeTopTab() {},
    removeItem(file) {
      const index = this.uploadlist.findIndex((item) => item.uid === file.uid);
      if (index === -1) return;

      this.uploadlist.splice(index, 1);
      if (index === this.currentUploadIndex) {
        this.uploadNextFile();
      }
    },
    async putObject(obj, client, file) {
      try {
        // 填写 Object 完整路径。Object 完整路径中不能包含 Bucket 名称。
        // 您可以通过自定义文件名（例如 exampleobject.txt）或文件完整路径（例如 exampledir/exampleobject.txt）的形式实现将数据上传到当前 Bucket 或 Bucket 中的指定目录。
        // data 对象可以自定义为 File 对象、Blob 数据。
        const fileurl =
          'qianchuan/material/' + this.advertiser_id + '/' + file.name;
        const result = await client.putObject({
          key: fileurl,
          body: obj,
          // headers,
          progress: (p, cpt) => {
            console.log('上传进度', cpt);
            // 获取上传进度。
            console.log('上传进度', p * 100);
          },
        });
        if (result.statusCode == 200) {
          //继续执行上传到千川素材库接口
          file.status = '同步至千川素材库';
          file.percent = 50;
          this.uploadQc(file, fileurl);
        } else {
          file.status = '上传失败';
          file.percent = 100;
        }
        console.log(result);
      } catch (e) {
        console.log(e);
      }
    },
    async uploadQc(file, fileurl) {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QC_UOLOAD_BY_LS_CLOUDE}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          fileurl: fileurl,
          filename: file.name,
        },
      });
      file.percent = 100;
      if (code == 0) {
        file.status = msg;
      } else {
        //延迟1秒执行
        setTimeout(async () => {
          await this.sysnVideo('E_COMMERCE');
          this.selectKey = 'E_COMMERCE';
          this.searchKey = data.material_id;
          await this.getQcData(true);
          file.status = '上传成功';
        }, 2000); // 2000毫秒 = 2秒
      }
    },
    getFileBlobData(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file); // 或者使用其他需要的方法，例如readAsText()
      });
    },
    async uploadFile() {
      if (this.isUploading) return;
      this.isUploading = true;
      this.currentUploadIndex = -1;
      await this.uploadNextFile();
    },
    async uploadNextFile() {
      this.currentUploadIndex++;
      if (this.currentUploadIndex >= this.uploadlist.length) {
        this.isUploading = false;
        return;
      }

      const currentFile = this.uploadlist[this.currentUploadIndex];
      if (currentFile.status === '上传成功') {
        await this.uploadNextFile();
        return;
      }

      try {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.QC_GET_LS_CONFIG}`,
          method: 'POST',
          params: {},
        });

        if (code === 0) {
          this.$message.error(msg);
          currentFile.status = '上传失败';
          currentFile.percent = 100;
          await this.uploadNextFile();
          return;
        }

        const client = new TOS({
          accessKeyId: data.AccessKeyId,
          accessKeySecret: data.SecretAccessKey,
          stsToken: data.SessionToken,
          region: 'cn-beijing',
          bucket: 'dczs',
        });

        const blobData = await this.getFileBlobData(currentFile.originFileObj);
        currentFile.status = '上传中';
        currentFile.percent = 0;

        await this.putObject(blobData, client, currentFile);
        await this.uploadNextFile();
      } catch (error) {
        console.error('Upload error:', error);
        currentFile.status = '上传失败';
        currentFile.percent = 100;
        await this.uploadNextFile();
      }
    },
    async retrySingleUpload(file) {
      const index = this.uploadlist.findIndex((item) => item.uid === file.uid);
      if (index === -1) return;

      this.uploadlist[index].status = '准备上传';
      this.uploadlist[index].percent = 0;

      if (!this.isUploading) {
        this.currentUploadIndex = index - 1;
        this.isUploading = true;
        await this.uploadNextFile();
      }
    },
    async retryFailedUploads() {
      const failedFiles = this.uploadlist.filter(
        (file) => file.status === '上传失败'
      );
      if (failedFiles.length === 0) {
        this.$message.info('没有需要重试的上传任务');
        return;
      }

      failedFiles.forEach((file) => {
        file.status = '准备上传';
        file.percent = 0;
      });

      if (!this.isUploading) {
        this.currentUploadIndex = -1;
        this.isUploading = true;
        await this.uploadNextFile();
      }
    },
    async handleVideoChange(info) {
      const newFile = info.file;
      const foundIndex = this.uploadlist.findIndex(
        (item) => item.uid === newFile.uid
      );

      if (foundIndex !== -1) {
        this.uploadlist.splice(foundIndex, 1, newFile);
      } else {
        this.uploadlist.push(newFile);
      }

      if (!this.isUploading) {
        await this.uploadFile();
      }
    },
    getMoreQcData() {
      this.page++;
      this.getQcData();
    },
    handleChange(val) {
      this.selectKey = val;
      this.searchKey = '';
      this.page = 1;
      this.video_cursor = '';
      this.list = [];
      this.selectAll = 0;
      this.folderList = [];
      if (val == '1') {
        this.getData();
      } else if (val == '2') {
        this.getAccountData();
      } else if (val == '3') {
        //获取文件夹
        //获取素材列表
        this.getTeamList();
        this.fetchFileList();
      } else {
        this.sysnVideo();
      }
    },
    async getTeamList() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_TEAM_USER_LIST}`,
        method: 'POST',
        params: {},
      });
      console.log('获取素材列表', data);
      this.teamList = data.list;
      this.team_user_id = this?.wxInfo?.id;
    },
    handleTeamChange(e) {
      console.log(e);
      this.team_user_id = e;
      this.fetchFileList();
    },
    handleFolderClick(item) {
      this.searchKey = '';
      console.log(item);
      this.currentCategoryId = item.id;
      // 更新文件夹路径
      const currentFolder = {
        id: item.id,
        name: item.fileName,
      };
      this.folderPath.push(currentFolder);
      this.fetchFileList();
    },
    // 获取文件列表
    async fetchFileList(isLoadMore = false) {
      if (!isLoadMore) {
        this.page = 1;
        this.list = [];
      } else {
        this.page++;
      }
      this.video_spinning = true; // 修改为表格加载状态
      try {
        // 先获取文件夹列表
        const folderRes = await requestHttp({
          api: `${qcApi.GET_MATERIAL_CATEGORY_LIST}`,
          method: 'POST',
          params: {
            pid: this.currentCategoryId,
            type: this.mediaType,
            searchKey: this.searchKey,
            team_user_id: this.team_user_id,
          },
        });

        // 再获取文件列表
        const fileRes = await requestHttp({
          api: `${qcApi.GET_MATERIAL_ATTACHMENT_LIST}`,
          method: 'POST',
          params: {
            cate_id: this.currentCategoryId || '',
            searchKey: this.searchKey,
            type: this.mediaType,
            page: this.page,
            pagesize: 1000,
            team_user_id: this.team_user_id,
          },
        });

        if (folderRes.code === 1 && fileRes.code === 1) {
          // 处理文件夹数据
          const folderList = folderRes.data.map((item) => ({
            id: item.id,
            key: item.id,
            fileName: item.name,
            size: '--',
            modifiedTime: item.updatetime || '--',
            type: 'folder',
            isEditing: false,
            editingName: '',
            editLoading: false,
          }));

          // 处理文件数据
          const list = fileRes.data.list.map((item) => ({
            key: item.id,
            id: item.material_id,
            fileName: item.filename,
            duration: item.duration,
            material_id: item.material_id,
            create_time: item.updatetime,
            filename: item.filename,
            size: this.formatFileSize(item.filesize),
            modifiedTime: item.updatetime,
            type: 'VIDEO',
            image_mode: 'VIDEO_VERTICAL',
            thumbnail: item.real_url || '',
            imageUrl: item.real_url || '',
            video_cover_url: item.real_url || '',
            isEditing: false,
            editingName: '',
            editLoading: false,
            url: item.url || '',
            source: 'LIANSHAN',
            title: item.filename,
            file_route: item.file_route,
          }));

          if (isLoadMore) {
            // 加载更多时只添加文件列表
            this.list = [...this.list, ...list];
          } else {
            this.folderList = [...folderList];
            // 首次加载时，文件夹在前，文件在后
            this.list = [...list];
          }

          // this.total = fileRes.data.count;
          // 计算是否还有更多时只考虑文件数量，不考虑文件夹
          // this.hasMore = this.fileList.length-folderList.length == this.total ? false : true;
        } else {
          message.error(folderRes.msg || fileRes.msg);
        }
      } catch (error) {
        console.log('----', error);
        message.error('获取列表失败');
      } finally {
        this.video_spinning = false; // 无论成功失败都关闭加载状态
      }
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (!size) return '--';
      const units = ['B', 'KB', 'MB', 'GB'];
      let index = 0;
      let fileSize = size;
      while (fileSize >= 1024 && index < units.length - 1) {
        fileSize /= 1024;
        index++;
      }
      return `${fileSize.toFixed(2)}${units[index]}`;
    },
    onSearch() {},
    onClose() {
      this.$emit('closeAddDrawer');
    },
    clearSelected() {
      Modal.confirm({
        title: '确认清空',
        content: '确定要清空所有已选视频吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.select_video_list = [];
          this.selectAll = 0;
        },
      });
    },
    onOk() {
      this.$emit('receive', {
        video_material_list: this.select_video_list,
        otherSelect: this.otherSelect,
      });
    },
    goToRootFolder() {
      this.searchKey = '';
      this.selectAll = 0;
      this.currentCategoryId = '';
      this.folderPath = [];
      this.fetchFileList();
    },
    navigateToFolder(index) {
      this.searchKey = '';
      console.log('点击了', this.searchKey);
      this.currentCategoryId = this.folderPath[index].id;
      this.folderPath = this.folderPath.slice(0, index + 1);
      this.fetchFileList();
    },
  },
};
</script>

<style lang="less" scoped>
.drawerFooter {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 111;
  display: flex;
  height: 70px;
}
.drawer-footer-materials {
  flex: 1;
  // max-width: 414px;
}
.select-small-list-container {
  display: flex;
  max-width: 450px;
  overflow: auto;
  padding-top: 5px;
}
.select-small-list-container {
  display: flex;
  max-width: 450px;
  overflow: auto;
  padding-top: 5px;
}
.select-small-list-container .image-con {
  margin-left: 14px;
  position: relative;
  width: 30px;
  height: 40px;
  background: #f4f4f4;
  border-radius: 4px;
}
.select-small-list-container .image-con .image-con-container {
  width: 30px;
  height: 40px;
  overflow: hidden;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.select-small-list-container .image-con .video-icon-image {
  width: 12px;
  height: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}
.select-small-list-container .image-con .delete-icon-image {
  width: 16px;
  height: 16px;
  top: -3px;
  right: -5px;
  z-index: 3;
  position: absolute;
  cursor: pointer;
}
.select_div {
  display: flex;
}
.tips {
  margin-top: 20px;
}
/deep/ .ant-select-selection {
  background: #f2f2f2;
}

.material-virtual-viewport {
  overflow: auto;
  position: relative;
  margin-top: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
}

.material-item {
  width: 180px;
  height: 270px;
  background: pink;
}

.material-row {
  position: absolute;
  // display: flex;
  justify-content: space-between;

  ::v-deep .video-container:not(:last-child) {
    margin-right: 3px;
  }
}

.material-row-bottom {
  position: absolute;
  width: 100%;
}
.empty {
  padding-top: 100px;
}
.common-loading-container {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.authTypeWapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-height: 60vh;
  overflow: auto;

  .authImg {
    width: 748px;
    height: 544px;
    margin: 0 auto;
  }

  .authBtn {
    cursor: pointer;
  }
}
.video-container {
  height: 430px;
  width: 200px;
  position: relative;
  border-radius: 4px;
  float: left;
  // overflow: hidden;
  .mask {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 8;
  }

  .select-border {
    border: 1px solid #eee;
    border-radius: 5px;
  }

  .not-select-border {
    // border: 1px solid transparent;
  }

  .selected-con {
    position: absolute;
    right: 0;
    top: 0;
    width: 36px;
    height: 36px;
    &-bg {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 12;
    }

    &-icon {
      display: block;
      position: absolute;
      top: 3px;
      right: 3px;
      z-index: 13;
    }
  }
  // display: flex;
}
.video-player-size-normal {
  width: 200px;
  height: 320px;
}
.byted-popover-wrapper {
  width: 100%;
}
.video-player {
  position: relative;
  border-radius: 4px;
}
.video-player-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: #000;
  opacity: 0.3;
  cursor: pointer;
}
.video-player .start-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 32px;
  height: 40px;
  background-image: url('https://p1-ad.byteimg.com/tos-cn-i-yt5q7rszul/abbc32596f064ad8a1e35642e0bcb29c~tplv-yt5q7rszul-image.image');
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.8;
  cursor: pointer;
  transform: translate(-50%, -50%);
}
.video-player .card-duration {
  position: absolute;
  top: 4px;
  left: 2px;
  padding: 0 3px;
  width: 40px;
  height: 22px;
  border-radius: 4px;
  background: #111;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  opacity: 0.88;
}
.video-player-like {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 13;
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-left: 10px;
  height: 48px;
  border-radius: 4px;
  background: linear-gradient(
    180deg,
    rgba(18, 18, 18, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
}
.byted-popover-wrapper {
  display: inline-block;
}
.video-player-like-icon {
  color: #fff;
}
.video-player-like-num {
  margin-left: 5px;
  margin-right: 10px;
  color: #fff;
  font-size: 12px;
}
.video-player-file-name {
  display: -webkit-box;
  overflow: hidden;
  autoprefixer: off;
  -webkit-box-orient: vertical;
  margin-top: 8px;
  // height: 44px;
  // color: #323335;
  text-overflow: ellipsis;
  word-break: break-all;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  -webkit-line-clamp: 1;
}
.video-player-poster {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-position: center;
  background-size: 100% auto;
  background-repeat: no-repeat;
  cursor: pointer;
}
.video-container .select-border {
  border: 1px solid #194ce5;
  border-radius: 5px;
}
.video-container .selected-con {
  position: absolute;
  right: 0;
  top: 0;
  width: 36px;
  height: 36px;
}
.video-container .selected-con-bg {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 12;
}
.video-container .selected-con-icon {
  display: block;
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 13;
}
.drawer-footer-btns {
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: center;
}

.authTxt {
  margin: 0 auto;
  width: 90%;
  text-align: left;
  font-size: 12px;
  margin-bottom: 5px;
}

.rowOperate {
  // display: flex;
  align-items: center;
  justify-content: flex-start;

  .actionItem {
    margin-left: 5px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.authModal {
  /deep/.ant-modal-footer {
    border: none;
  }
}
.addbtn {
  text-align: center;
  line-height: 30px;
  margin-top: 20px;
}

.statistic-wrapper {
  margin-top: 3px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  background: #f2f2f2;
  border-radius: 3px;
  padding: 3px;
}
.statistic-wrapper .statistic-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 17px;
}
.statistic-wrapper .statistic-item .label {
  font-size: 12px;
  color: #999;
}
.statistic-wrapper .statistic-item .value {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
}
.statistic-wrapper .statistic-item .value.profit {
  color: #f00000;
  font-weight: bold;
}
.statistic-wrapper .statistic-item .value.loss {
  color: #00a511;
  font-weight: bold;
}
// /deep/ .ant-spin-nested-loading{
//   display: none;
// }
.file_box {
  // width: 200px !important;
  height: 410px;
  position: relative;
  border-radius: 4px;
  float: left;
  margin-right: 8px;
  margin-bottom: 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
    border-color: #d9d9d9;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    padding: 0 12px;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.85);
  }

  .folder-content {
    text-align: center;
    align-items: center;
    width: 100%;

    .anticon {
      font-size: 24px;
      color: #faad14;
    }

    .folder-name {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 140px;
    }
  }
}

.folder-navigation {
  margin: 16px 0;
  padding: 8px 16px;
  background: #fafafa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  .ant-btn-link {
    padding: 0 4px;
    height: 24px;
    line-height: 24px;
  }

  .anticon {
    color: #d9d9d9;
    margin: 0 4px;
  }
}
.ant-upload-list {
  display: none !important;
}
</style>
